import { Box, Group, Tooltip as MTooltip, TooltipProps } from '@mantine/core';
import { useUserPrefsStore } from '../../app/store';
// import {useTID} from '../../helpers/useTestId'

// interface ITooltipProps extends TooltipProps {
//   testid: string;
// }

export const Tooltip = (props: TooltipProps) => {
  const showTooltips = useUserPrefsStore((state) => state.enableTooltips);
  // const TID = useTID('Tooltip', props.testid)

  const defaultValues = {
    color: 'gray',
    placement: 'center',
    position: 'top',
    withArrow: true
  };
  let combinedProps = Object.assign({}, defaultValues, props);

  if (!showTooltips) {
    return <Box>{props.children}</Box>;
  }

  return (
    <Group>
      <MTooltip {...combinedProps}>{props.children}</MTooltip>
    </Group>
  );
};
